export const iconFontAwesomeEditingBrush = (
	<i className="fa-solid fa-brush"></i>
);
